'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var framerMotion = require('framer-motion');



Object.keys(framerMotion).forEach(function (k) {
	if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return framerMotion[k]; }
	});
});
